import React, { useState, useEffect } from "react";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";
import Loader from "../../components/Loader";
import { loggedInUser, teamIDCheck } from "../../utils/store";
import { useAtom } from "jotai";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import FormInput from "../../components/Forms/FormInput";
import { post, put, get } from "../../server";
import { FORM_BUILDER } from "../../utils/constants/apiUrl";
import { FORM_BUILDER_CARD } from "../../utils/constants/apiUrl";
import functionTypes from "../../utils/constants/functionTypes";
import showToast from "../../helpers/showToast";
import { Form } from "react-bootstrap";
import { Colors } from "../../utils/data/CardFunctionsData";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { BsFillPersonFill } from "react-icons/bs";
import { MdEmail, MdLocationOn, MdOutlineContentCopy } from "react-icons/md";
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import { BiSolidPhoneCall, BiSolidTrash, BiEdit } from "react-icons/bi";
import { IoDocumentText } from "react-icons/io5";
import InputText from "../../assets/images/global_icons/inputText.svg";
import DraggableIcon from "../../assets/images/function_page_icons/dragable-icon.svg";
import Line from "../../assets/images/function_page_icons/line.svg";
import Heading from "../../assets/images/function_page_icons/heading.svg";
import List from "../../assets/images/global_icons/List.svg";
import RadioGroup from "../../assets/images/global_icons/RadioGroup.svg";
import Checkbox from "../../assets/images/global_icons/checkbox.svg";
import Dropdown from "../../assets/images/global_icons/dropdown.svg";
import CalendarIcon from "../../assets/images/global_icons/DatePicker.svg";
import Paragraph from "../../assets/images/global_icons/paragraph.svg";
import Textarea from "../../assets/images/global_icons/TextArea.svg";
import Upload from "../../assets/images/global_icons/uploadFile.svg";
import AddLink from "../../assets/images/global_icons/Link.svg";
import Delete from "../../assets/images/global_icons/delete.svg";
import User from "../../assets/images/global_icons/user.svg";
import Email from "../../assets/images/global_icons/email.svg";
import Call from "../../assets/images/global_icons/call.svg";
import Location from "../../assets/images/global_icons/location-1.svg";
import Information from "../../assets/images/global_icons/information.svg";
import useFunctionsCount from "../../hooks/useFunctionsCount";
import { trackEvent } from "../../utils/mixpanel";
import Draggable from "react-draggable";
import "react-phone-input-2/lib/style.css";
import { seParams } from "react-router-dom";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import StepArrow from "../../assets/images/global_icons/step-arrow.svg";
import {
  FaHeading,
  FaMinus,
  FaParagraph,
  FaList,
  FaKeyboard,
  FaRegCommentDots,
  FaDotCircle,
  FaCheckSquare,
  FaChevronDown,
  FaUpload,
  FaCalendarAlt,
  FaLink,
} from "react-icons/fa";
import introJs from "intro.js";

function FormBuilder() {
  // ===============================
  // 1. HOOKS AND ROUTER SETUP
  // ===============================

  let { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");
  const pageType = searchParams.get("type");
  const prefillType = searchParams.get("prefill");
  const cardFormBuilderData = location.state?.cardFormBuilderData;
  const navigate = useNavigate();
  const { updateCount } = useFunctionsCount();
  const countryCodes = require("country-codes-list");
  console.log("cardFormBuilderData", cardFormBuilderData);
  // ===============================
  // 2. ATOM STATE MANAGEMENT
  // ===============================

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);

  // ===============================
  // 3. COMPONENT STATE MANAGEMENT
  // ===============================

  // Loading and UI states
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("title");
  const [showSubmitButton, setShowSubmitButton] = useState(false);

  // Form data states
  const [formName, setFormName] = useState("");
  const [errors, setErrors] = useState("");

  // Form elements states
  const [formElements, setFormElements] = useState([]);
  const [quickBuildElements, setQuickBuildElements] = useState([]);
  const [personalizedBuildElements, setPersonalizedBuildElements] = useState(
    []
  );
  const [selectedFieldTypes, setSelectedFieldTypes] = useState(
    new Array(formElements.length).fill("")
  );
  const [isRequired, setIsRequired] = useState(
    new Array(formElements.length).fill(false)
  );
  const [formFieldValues, setFormFieldValues] = useState({});

  // Drag and drop states
  const [elementGroups, setElementGroups] = useState([]);
  const [groupPositions, setGroupPositions] = useState({});
  const [dragPositions, setDragPositions] = useState({});

  // Modal states
  const [editingIndex, setEditingIndex] = useState(null);
  const [editLabel, setEditLabel] = useState("");
  const [editOptions, setEditOptions] = useState([]);

  // ===============================
  // 4. CONSTANTS AND CONFIGURATIONS
  // ===============================

  const tabOrder = ["title", "quickBuild", "personalizedBuild"];
  const type = searchParams.get("type");
  // console.log('TYPE from URL:', type);

  // Field type options for dropdowns
  const FIELD_TYPE_OPTIONS = [
    { value: "first_name", label: "First Name" },
    { value: "last_name", label: "Last Name" },
    { value: "email", label: "Email" },
    { value: "card_type", label: "Card Type" },
    { value: "company", label: "Company" },
    { value: "company_position", label: "Company Position" },
    { value: "logo", label: "Logo" },
    { value: "background_image", label: "Background Image" },
    { value: "profile_image", label: "Profile Image" },
    { value: "country", label: "Country" },
    { value: "city", label: "City" },
    { value: "state", label: "State" },
    { value: "address", label: "Address" },
    { value: "description", label: "Information" },
    { value: "website_url", label: "Website" },
    { value: "pronouns", label: "Pronouns" },
    { value: "phone_type", label: "Phone Type" },
    { value: "country_phone", label: "Country Phone" },
    { value: "phone_number", label: "Phone Number" },
    { value: "flag_code", label: "Country Flag" },
    { value: "facebook", label: "Facebook" },
    { value: "instagram", label: "Instagram" },
    { value: "linkedIn", label: "LinkedIn" },
    { value: "twitter", label: "Twitter" },
    { value: "snapChat", label: "SnapChat" },
    { value: "tiktok", label: "Tiktok" },
    { value: "youtube", label: "Youtube" },
    { value: "Google", label: "Google" },
    { value: "custom", label: "Custom" },
    { value: "other", label: "Other" },
  ];

  // Mapping function for card_form_builder data
  const mapCardFormBuilderToQuickBuild = (cardFormBuilderData) => {
    if (!cardFormBuilderData || cardFormBuilderData.length === 0)
      return { elements: [], checkedIds: [] };

    const typeMapping = {
      email: { fieldType: "email", preDefineId: 3 },
      name: { fieldType: "first_name", preDefineId: 1 },
      phone_number: { fieldType: "contact_no", preDefineId: 4 },
    };

    const elements = [];
    const checkedIds = [];

    cardFormBuilderData.forEach((cardField) => {
      const mapping = typeMapping[cardField.type];
      if (mapping) {
        const element = {
          type: cardField.type === "phone_number" ? "custom" : "input",
          label: cardField.label,
          isPreDefined: true,
          fieldType: mapping.fieldType,
        };
        elements.push(element);
        checkedIds.push(mapping.preDefineId);
      }
    });

    return { elements, checkedIds };
  };

  // Pre-defined form elements for quick build
  const [preDefineItems, setPreDefineItems] = useState([
    {
      id: 1,
      // icon: <BsFillPersonFill />,
      icon: <img src={User} />,
      label: "First Name",
      checked: false,
      type: "input",
      field_type: "first_name",
    },
    {
      id: 2,
      // icon: <BsFillPersonFill />,
      icon: <img src={User} />,
      label: "Last Name",
      checked: false,
      type: "input",
      field_type: "last_name",
    },
    {
      id: 3,
      // icon: <MdEmail />,
      icon: <img src={Email} />,
      label: "Email Address",
      checked: false,
      type: "input",
      field_type: "email",
    },
    {
      id: 4,
      // icon: <BiSolidPhoneCall />,
      icon: <img src={Call} />,
      label: "Phone Number",
      checked: false,
      type: "custom",
      field_type: "contact_no",
    },
    {
      id: 5,
      // icon: <MdLocationOn />,
      icon: <img src={Location} />,
      label: "Address",
      checked: false,
      type: "custom",
      field_type: "location",
    },
    {
      id: 6,
      // icon: <IoDocumentText />,
      icon: <img src={Information} />,
      label: "Information",
      checked: false,
      type: "textarea",
      field_type: "description",
    },
  ]);

  // ===============================
  // 5. UTILITY FUNCTIONS
  // ===============================

  /**
   * Generate country options for phone input
   * @returns {Array} Array of country options with value and label
   */
  const generateCountryOptions = () => {
    const myCountryCodesObject = countryCodes.customList(
      "countryCode",
      "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
    );
    const countryOptions = Object.entries(myCountryCodesObject).map(
      ([code, label]) => ({
        value: code,
        label: label.replace(`[${code}] `, ""),
      })
    );
    return countryOptions;
  };

  /**
   * Prevent drag when clicking on form inputs
   */
  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  const handleInputFocus = (e) => {
    e.stopPropagation();
  };

  /**
   * Handle form field value changes in Quick Build
   * @param {string} fieldType - The field type identifier
   * @param {string} value - The new value
   */
  const handleFormFieldChange = (fieldType, value) => {
    setFormFieldValues((prev) => ({
      ...prev,
      [fieldType]: value,
    }));
  };

  /**
   * Group elements for better UI organization (e.g., first name + last name)
   * @param {Array} elements - Array of form elements to group
   * @returns {Array} Array of grouped elements
   */
  const groupElements = (elements) => {
    const groups = [];
    const processed = new Set();

    // Filter out undefined/null elements first
    const validElements = elements.filter((element) => element != null);

    validElements.forEach((element, index) => {
      if (processed.has(index)) return;

      // Group first name with last name if both exist
      if (element.fieldType === "first_name") {
        const lastNameIndex = validElements.findIndex(
          (el, i) => i > index && el && el.fieldType === "last_name"
        );
        if (lastNameIndex !== -1) {
          groups.push({
            id: `name-group-${groups.length}`,
            type: "name-group",
            elements: [element, validElements[lastNameIndex]],
          });
          processed.add(index);
          processed.add(lastNameIndex);
          return;
        }
      }

      // Group location fields
      if (element.fieldType === "location") {
        groups.push({
          id: `location-group-${groups.length}`,
          type: "location-group",
          elements: [element],
        });
        processed.add(index);
        return;
      }

      // Group phone number fields
      if (element.fieldType === "contact_no") {
        groups.push({
          id: `phone-group-${groups.length}`,
          type: "phone-group",
          elements: [element],
        });
        processed.add(index);
        return;
      }

      // Single element groups for everything else
      groups.push({
        id: `single-group-${groups.length}`,
        type: "single",
        elements: [element],
      });
      processed.add(index);
    });

    return groups;
  };

  // ===============================
  // 6. TAB NAVIGATION HANDLERS
  // ===============================

  /**
   * Handle navigation to next tab with validation
   */
  const handleNext = () => {
    const currentIndex = tabOrder.indexOf(activeTab);

    // Validate form name on title tab
    if (activeTab === "title" && !formName.trim()) {
      setErrors("Please enter title");
      return;
    }

    // Move to next tab if not at the end
    if (currentIndex < tabOrder.length - 1) {
      setActiveTab(tabOrder[currentIndex + 1]);
    }
  };

  /**
   * Handle navigation to previous tab
   */
  const handleBack = () => {
    const currentIndex = tabOrder.indexOf(activeTab);

    // Move to previous tab if not at the beginning
    if (currentIndex > 0) {
      setActiveTab(tabOrder[currentIndex - 1]);
    }
  };

  /**
   * Navigate back to previous page
   */
  const handleGoBack = () => {
    navigate(-1);
  };

  // ===============================
  // 7. QUICK BUILD HANDLERS
  // ===============================

  /**
   * Toggle pre-defined checkbox items for quick build
   * @param {number} id - ID of the checkbox item to toggle
   */
  const toggleCheckbox = (id) => {
    // Update checkbox state
    const updatedCheckboxItems = preDefineItems.map((item) =>
      item.id === id ? { ...item, checked: !item.checked } : item
    );
    setPreDefineItems(updatedCheckboxItems);

    const toggledItem = preDefineItems.find((item) => item.id === id);
    const isCurrentlyChecked = toggledItem?.checked;

    if (isCurrentlyChecked) {
      // Remove from quickBuildElements if unchecking
      setQuickBuildElements((prev) =>
        prev.filter((element) => element.fieldType !== toggledItem.field_type)
      );
    } else {
      // Add to quickBuildElements if checking
      const itemToAdd = {
        type: toggledItem.type,
        label: toggledItem.label,
        isPreDefined: true,
        fieldType: toggledItem.field_type,
      };
      setQuickBuildElements((prev) => [...prev, itemToAdd]);
    }

    // Update submit button visibility
    const willHaveElements = isCurrentlyChecked
      ? quickBuildElements.filter(
          (el) => el.fieldType !== toggledItem.field_type
        ).length > 0
      : quickBuildElements.length + 1 > 0;

    setShowSubmitButton(willHaveElements);
  };

  // ===============================
  // 8. DRAG AND DROP HANDLERS
  // ===============================

  /**
   * Handle dragging of group elements (Quick Build)
   * @param {Event} e - Drag event
   * @param {Object} data - Drag data with position
   * @param {string} groupId - ID of the group being dragged
   */
  const handleDrag = (e, data, groupId) => {
    setGroupPositions((prev) => ({
      ...prev,
      [groupId]: { x: 0, y: data.y },
    }));
  };

  /**
   * Handle end of group drag (Quick Build)
   * @param {Event} e - Drag event
   * @param {Object} data - Drag data with final position
   * @param {string} groupId - ID of the group that was dragged
   */
  const handleStop = (e, data, groupId) => {
    const groups = [...elementGroups];
    const draggedGroup = groups.find((g) => g.id === groupId);

    if (!draggedGroup) return;

    const otherGroups = groups.filter((g) => g.id !== groupId);
    const elementHeight = 120;
    const insertIndex = Math.max(0, Math.floor(data.y / elementHeight));

    // Reorder the groups
    const newOrder = [...otherGroups];
    newOrder.splice(Math.min(insertIndex, newOrder.length), 0, draggedGroup);

    setElementGroups(newOrder);
    setGroupPositions((prev) => ({ ...prev, [groupId]: { x: 0, y: 0 } }));

    // Update quickBuildElements to match new order
    const reorderedElements = [];
    newOrder.forEach((group) => {
      reorderedElements.push(...group.elements);
    });
    setQuickBuildElements(reorderedElements);
  };

  /**
   * Handle dragging of individual elements (Personalized Build)
   * @param {Event} e - Drag event
   * @param {Object} data - Drag data with position
   * @param {string} elementId - ID of the element being dragged
   */
  const handleElementDrag = (e, data, elementId) => {
    if (!elementId) return;

    setDragPositions((prev) => ({
      ...prev,
      [elementId]: { x: 0, y: data.y },
    }));
  };

  /**
   * Handle end of element drag (Personalized Build)
   * @param {Event} e - Drag event
   * @param {Object} data - Drag data with final position
   * @param {string} elementId - ID of the element that was dragged
   */
  const handleElementDragStop = (e, data, elementId) => {
    const validElements = personalizedBuildElements.filter(
      (el) => el != null && el.id != null
    );

    const draggedElement = validElements.find((el) => el.id === elementId);
    if (!draggedElement) return;

    const otherElements = validElements.filter((el) => el.id !== elementId);
    const insertIndex = Math.floor(data.y / 150);
    const newOrder = [...otherElements];

    newOrder.splice(
      Math.max(0, Math.min(insertIndex, newOrder.length)),
      0,
      draggedElement
    );

    setPersonalizedBuildElements(newOrder);
    setDragPositions((prev) => ({ ...prev, [elementId]: { x: 0, y: 0 } }));
  };

  // ===============================
  // 9. PERSONALIZED BUILD HANDLERS
  // ===============================

  /**
   * Add a new custom element to personalized build
   * @param {string} type - Type of element to add
   * @param {string} label - Label for the element
   * @param {Array} options - Options for dropdown/radio/checkbox elements
   */
  const addElement = (type, label, options = []) => {
    // Validate required options for certain element types
    if (
      (type === "radio" && options.length < 2) ||
      (type === "checkbox" && options.length < 1) ||
      (type === "list" && options.length < 1) ||
      (type === "dropdown" && options.length < 2)
    ) {
      return;
    }

    // Define default field types based on element type
    const getDefaultFieldType = (elementType) => {
      switch (elementType) {
        case "input":
          return "custom";
        case "textarea":
          return "description";
        case "date":
          return "date_picker";
        case "upload":
          return "file_uploader";
        case "link":
          return "website_url";
        case "heading":
        case "paragraph":
        case "line":
        case "list":
        case "radio":
        case "checkbox":
        case "dropdown":
          return "other";
        default:
          return "custom";
      }
    };

    const newElement = {
      id: `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      type,
      label,
      options: options || [],
      isMandatory: false,
      fieldType: getDefaultFieldType(type),
      placeholder: "",
      customText: label,
      linkUrl: "",
    };

    setPersonalizedBuildElements((prev) => [
      ...prev.filter((el) => el != null),
      newElement,
    ]);

    setShowSubmitButton(true);
  };

  /**
   * Delete a personalized element by ID
   * @param {string} elementId - ID of element to delete
   */
  const deletePersonalizedElement = (elementId) => {
    setPersonalizedBuildElements((prev) =>
      prev.filter((element) => element.id !== elementId)
    );

    // Clean up drag positions
    setDragPositions((prev) => {
      const newPositions = { ...prev };
      delete newPositions[elementId];
      return newPositions;
    });
  };

  const handleDeleteGroup = (groupId) => {
    const newGroups = elementGroups.filter((group) => group.id !== groupId);
    setElementGroups(newGroups);

    // Optional: Also update quickBuildElements to remove deleted group elements
    const newQuickElements = newGroups.flatMap((group) => group.elements);
    setQuickBuildElements(newQuickElements);
  };

  /**
   * Update a property of a personalized element
   * @param {string} elementId - ID of element to update
   * @param {string} property - Property name to update
   * @param {any} value - New value for the property
   */
  const updateElementProperty = (elementId, property, value) => {
    setPersonalizedBuildElements((prev) =>
      prev.map((element) =>
        element.id === elementId ? { ...element, [property]: value } : element
      )
    );
  };

  /**
   * Add an option to an element (for dropdown, radio, checkbox)
   * @param {string} elementId - ID of element to add option to
   */
  const addOptionToElement = (elementId) => {
    setPersonalizedBuildElements((prev) =>
      prev.map((element) =>
        element.id === elementId
          ? {
              ...element,
              options: [
                ...element.options,
                `Option ${element.options.length + 1}`,
              ],
            }
          : element
      )
    );
  };

  /**
   * Update a specific option of an element
   * @param {string} elementId - ID of element containing the option
   * @param {number} optionIndex - Index of option to update
   * @param {string} value - New value for the option
   */
  const updateElementOption = (elementId, optionIndex, value) => {
    setPersonalizedBuildElements((prev) =>
      prev.map((element) =>
        element.id === elementId
          ? {
              ...element,
              options: element.options.map((option, index) =>
                index === optionIndex ? value : option
              ),
            }
          : element
      )
    );
  };

  /**
   * Delete a specific option from an element
   * @param {string} elementId - ID of element containing the option
   * @param {number} optionIndex - Index of option to delete
   */
  const deleteElementOption = (elementId, optionIndex) => {
    setPersonalizedBuildElements((prev) =>
      prev.map((element) =>
        element.id === elementId
          ? {
              ...element,
              options: element.options.filter(
                (_, index) => index !== optionIndex
              ),
            }
          : element
      )
    );
  };

  // ===============================
  // 10. LEGACY FORM ELEMENT HANDLERS
  // ===============================

  /**
   * Handle field type change for legacy form elements
   * @param {string} value - New field type value
   * @param {number} index - Index of element to update
   */
  const handleFieldTypeChange = (value, index) => {
    const updatedSelectedFieldTypes = [...selectedFieldTypes];
    updatedSelectedFieldTypes[index] = value;
    setSelectedFieldTypes(updatedSelectedFieldTypes);
  };

  /**
   * Toggle required status for legacy form elements
   * @param {number} index - Index of element to toggle
   */
  const toggleIsRequired = (index) => {
    const updatedIsRequired = [...isRequired];
    updatedIsRequired[index] = !updatedIsRequired[index];
    setIsRequired(updatedIsRequired);
  };

  /**
   * Remove a legacy form element
   * @param {number} index - Index of element to remove
   */
  const removeElement = (index) => {
    const updatedElements = [...formElements];
    updatedElements.splice(index, 1);
    setFormElements(updatedElements);
    setShowSubmitButton(updatedElements.length > 0);
  };

  /**
   * Copy a legacy form element
   * @param {number} index - Index of element to copy
   */
  const copyElement = (index) => {
    const copiedElement = { ...formElements[index] };
    setFormElements([...formElements, copiedElement]);
    setShowSubmitButton(true);
  };

  // ===============================
  // 11. MODAL HANDLERS
  // ===============================

  /**
   * Open edit modal for legacy form elements
   * @param {number} index - Index of element to edit
   * @param {string} label - Current label of element
   * @param {Array} options - Current options of element
   */
  const openEditModal = (index, label, options) => {
    setEditingIndex(index);
    setEditLabel(label);
    setEditOptions(options || []);
  };

  /**
   * Save changes from edit modal
   */
  const saveEdit = () => {
    if (editingIndex !== null) {
      const updatedElements = [...formElements];
      if (editOptions.length === 0) {
        updatedElements[editingIndex].label = editLabel;
      } else {
        updatedElements[editingIndex].label = editLabel;
        updatedElements[editingIndex].options = editOptions;
      }
      setFormElements(updatedElements);
    }

    // Reset modal state
    setEditingIndex(null);
    setEditLabel("");
    setEditOptions([]);
  };

  // ===============================
  // 12. API FUNCTIONS
  // ===============================

  /**
   * Fetch existing form data for editing
   */
  const getFormData = async () => {
    try {
      let { status, message, data } = await get(
        `${FORM_BUILDER}/${id}`,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        setFormName(data.name);

        const quickBuildElementsFromAPI = [];
        const personalizedBuildElementsFromAPI = [];
        const preDefinedFieldTypes = [
          "first_name",
          "last_name",
          "email",
          "contact_no",
          "location",
          "description",
        ];

        // Transform API data to component format
        data.formBuilderField.forEach((field) => {
          const element = {
            type: field.type === "inputbox" ? "input" : field.type,
            label: field.label,
            options:
              field.formBuilderFieldData?.map((option) => option.data) || [],
            isPreDefined: field.is_predefined,
            fieldType: field.field_type,
            isMandatory: field.is_required,
          };

          // Add element-specific properties based on type
          if (!field.is_predefined) {
            // Generate unique ID for personalized elements
            element.id = `${element.type}_${Date.now()}_${Math.random()
              .toString(36)
              .substr(2, 9)}`;

            // Restore saved values based on element type
            if (field.default_value) {
              switch (element.type) {
                case "heading":
                case "paragraph":
                  element.customText = field.default_value;
                  break;
                case "link":
                  element.linkUrl = field.default_value;
                  break;
                case "input":
                case "textarea":
                  element.placeholder = field.default_value;
                  break;
                case "radio":
                case "checkbox":
                case "dropdown":
                case "list":
                  element.options = Array.isArray(field.default_value)
                    ? field.default_value
                    : [];
                  break;
              }
            }
          }

          // Separate into appropriate arrays
          if (field.is_predefined) {
            quickBuildElementsFromAPI.push(element);

            // Update preDefineItems checkboxes
            setPreDefineItems((prev) =>
              prev.map((item) =>
                item.field_type === field.field_type
                  ? { ...item, checked: true }
                  : item
              )
            );
          } else {
            personalizedBuildElementsFromAPI.push(element);
          }
        });

        // Set the elements
        setQuickBuildElements(quickBuildElementsFromAPI);
        setPersonalizedBuildElements(personalizedBuildElementsFromAPI);

        // Update other states
        setShowSubmitButton(true);

        // Set active tab based on what elements exist
        // if (personalizedBuildElementsFromAPI.length > 0) {
        //   setActiveTab("personalizedBuild");
        // } else if (quickBuildElementsFromAPI.length > 0) {
        //   setActiveTab("quickBuild");
        // } else {
        //   setActiveTab("title");
        // }
      } else {
        showToast(status, message);
      }
    } catch (error) {
      console.error("Error fetching form data:", error);
      showToast(false, "Error loading form data");
    } finally {
      setLoading(false);
    }
  };

  /**
   * Submit form data (create or update)
   * @param {Event} e - Form submit event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const isNew = !id;
    const source = dynamicQRCodeId
      ? "QR Code"
      : searchParams.has("team_id") && searchParams.has("user_id")
      ? "Team Function"
      : "Function Page";

    const successMessage = isNew
      ? `Lead Builder successfully added from ${source}`
      : `Lead Builder successfully updated from ${source}`;

    try {
      // Combine all form elements
      // Combine all form elements
      const allElements = [...quickBuildElements, ...personalizedBuildElements];

      const formBuilderFields = allElements.map((element, index) => {
        const fieldData =
          element.type === "color"
            ? Colors.map((color) => color.bgColor)
            : element.options || [];

        // Ensure field_type is not empty
        let fieldType = element.fieldType;
        if (!fieldType || fieldType.trim() === "") {
          switch (element.type) {
            case "input":
            case "inputbox":
              fieldType = "custom";
              break;
            case "textarea":
              fieldType = "description";
              break;
            case "date":
              fieldType = "date_picker";
              break;
            case "upload":
              fieldType = "file_uploader";
              break;
            case "link":
              fieldType = "website_url";
              break;
            default:
              fieldType = "other";
          }
        }

        // Get default value for this field
        let defaultValue = "";

        if (element.isPreDefined) {
          // Quick Build elements - get from formFieldValues
          defaultValue = formFieldValues[element.fieldType] || "";

          // Handle special field types for Quick Build
          if (element.fieldType === "location") {
            defaultValue = {
              address: formFieldValues[`${element.fieldType}_address`] || "",
              country: formFieldValues[`${element.fieldType}_country`] || "",
              state: formFieldValues[`${element.fieldType}_state`] || "",
              city: formFieldValues[`${element.fieldType}_city`] || "",
            };
          } else if (element.fieldType === "contact_no") {
            defaultValue = {
              type: formFieldValues[`${element.fieldType}_type`] || "",
              number: formFieldValues[element.fieldType] || "",
            };
          }
        } else {
          switch (element.type) {
            case "heading":
            case "paragraph":
              defaultValue = element.customText || "";
              break;
            case "link":
              defaultValue = element.linkUrl || "";
              break;
            case "input":
            case "textarea":
              defaultValue =
                formFieldValues[element.id] || element.placeholder || "";
              break;
            case "radio":
            case "checkbox":
            case "dropdown":
            case "list":
              defaultValue = element.options || [];
              break;
            case "line":
              defaultValue = "divider";
              break;
            default:
              defaultValue = formFieldValues[element.fieldType] || "";
          }
        }

        return {
          label: element.label,
          type: element.type === "input" ? "inputbox" : element.type,
          field_type: fieldType,
          is_required: element.isPreDefined ? true : false,
          is_predefined: element.isPreDefined || false,
          formBuilderFieldData: fieldData,
          default_value: defaultValue,
        };
      });

      let payload;

      if (type === "business") {
        payload = {
          team_id: userTeamId,
          name: formName,
          // function_type: type === "business" ? "card" : "form_builder",
          function_type: type === "business" ? "card" : "form_builder",
          cardFormBuilderFields: formBuilderFields,
          dynamic_qr_code_id: dynamicQRCodeId,
        };
      } else {
        payload = {
          team_id: userTeamId,
          name: formName,
          // function_type: type === "business" ? "card" : "form_builder",
          function_type: type === "business" ? "card" : "form_builder",
          formBuilderFields: formBuilderFields,
          dynamic_qr_code_id: dynamicQRCodeId,
        };
      }

      let response;

      if (type === "business") {
        // Update existing form
        trackEvent("Lead Builder Update Attempt", {
          isNew,
          form_name: formName,
          team_id: userTeamId,
          dynamic_qr_code_id: dynamicQRCodeId || null,
          payload,
        });
        response = await post(
          FORM_BUILDER_CARD,
          payload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
        // response = await put(
        //   type === "business"
        //     ? `${FORM_BUILDER_CARD}`
        //     : `${FORM_BUILDER}/${id}`,
        //   payload,
        //   loggedUser?.token || null
        // );
      } else if (id) {
        // Update existing form
        trackEvent("Lead Builder Update Attempt", {
          isNew,
          form_name: formName,
          team_id: userTeamId,
          dynamic_qr_code_id: dynamicQRCodeId || null,
          payload,
        });
        response = await put(
          userTeamId ? `${FORM_BUILDER}` : `${FORM_BUILDER}/${id}`,
          payload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
        // response = await put(
        //   type === "business"
        //     ? `${FORM_BUILDER_CARD}`
        //     : `${FORM_BUILDER}/${id}`,
        //   payload,
        //   loggedUser?.token || null
        // );
      } else {
        // Create new form
        response = await post(
          `${FORM_BUILDER}`,
          payload,
          Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
        );
      }

      const { status, message, data } = response;

      if (status) {
        // Track success event
        trackEvent(id ? "Lead Builder Updated" : "Lead Builder Created", {
          form_name: formName,
          response: data,
        });

        // Update function count for new forms
        if (!id) {
          updateCount(
            functionTypes.FORM_BUILDER,
            functionTypes.ADD,
            dynamicQRCodeId
          );
        }

        // Navigate to listing page
        if (dynamicQRCodeId) {
          navigate(
            `/function/formBuilderListing?dynamic_qr_code=${dynamicQRCodeId}`
          );
        } else {
          navigate("/function/formBuilderListing");
        }
      } else {
        // Track failure event
        trackEvent(
          id ? "Lead Builder Update Failed" : "Lead Builder Creation Failed",
          {
            form_name: formName,
            error: message,
          }
        );

        if (!id && !formName.trim()) {
          setErrors("Please enter form name");
        }
        showToast(status, message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      showToast(false, "An error occurred while saving the form");
    } finally {
      setLoading(false);
    }
  };

  // ===============================
  // 13. RENDER HELPER FUNCTIONS
  // ===============================

  /**
   * Render Quick Build form elements (without drag handles)
   * @param {Object} element - Element to render
   * @param {number} index - Index of element
   * @returns {JSX.Element|null} Rendered element or null
   */
  const renderQuickBuildElement = (element, index) => {
    if (!element) return null;

    return (
      <div
        className="position-relative mb-4"
        key={`${element.fieldType}-${index}`}
      >
        {element.type === "input" && (
          <div className="input-with dropdown">
            <FormInput
              type="text"
              label={element?.label}
              name={element?.label}
              value={formFieldValues[element.fieldType] || ""}
              onChange={(e) =>
                handleFormFieldChange(element.fieldType, e.target.value)
              }
              onClick={handleInputClick}
              onFocus={handleInputFocus}
              disabled
            />
          </div>
        )}

        {element.type === "textarea" && (
          <div className="form-group">
            <label className="">{element?.label}</label>
            <textarea
              className="globalTextArea form-control"
              type="text"
              name="description"
              value={formFieldValues[element.fieldType] || ""}
              onChange={(e) =>
                handleFormFieldChange(element.fieldType, e.target.value)
              }
              onClick={handleInputClick}
              onFocus={handleInputFocus}
              disabled
            ></textarea>
          </div>
        )}

        {element.type === "custom" &&
          (element.fieldType === "location" ? (
            <div className="row">
              <div className="col-lg-12">
                <div>
                  <FormInput
                    type="text"
                    label="Address Lines"
                    placeholder="Enter Address Line"
                    value={
                      formFieldValues[`${element.fieldType}_address`] || ""
                    } // ✅ Controlled value
                    onChange={(e) =>
                      handleFormFieldChange(
                        `${element.fieldType}_address`,
                        e.target.value
                      )
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div>
                  <FormInput
                    type="text"
                    label="Country"
                    placeholder="Select country"
                    value={
                      formFieldValues[`${element.fieldType}_country`] || ""
                    } // ✅ Controlled value
                    onChange={(e) =>
                      handleFormFieldChange(
                        `${element.fieldType}_country`,
                        e.target.value
                      )
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div>
                  <FormInput
                    type="text"
                    label="State"
                    placeholder="Enter state"
                    value={formFieldValues[`${element.fieldType}_state`] || ""} // ✅ Controlled value
                    onChange={(e) =>
                      handleFormFieldChange(
                        `${element.fieldType}_state`,
                        e.target.value
                      )
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div>
                  <FormInput
                    type="text"
                    label="City"
                    placeholder="Enter city"
                    value={formFieldValues[`${element.fieldType}_city`] || ""} // ✅ Controlled value
                    onChange={(e) =>
                      handleFormFieldChange(
                        `${element.fieldType}_city`,
                        e.target.value
                      )
                    }
                    disabled
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-12 form-group mb-0">
                <label className="formLabel label">{element.label}</label>
              </div>
              {/* <div className="col-md-4">
                <div>
                  <div className="input-group globalInputWithIcon">
                    <select
                      style={{ border: "0" }}
                      className="form-select customSelect"
                      value={formFieldValues[`${element.fieldType}_type`] || ""} // ✅ Controlled value
                      onChange={(e) =>
                        handleFormFieldChange(
                          `${element.fieldType}_type`,
                          e.target.value
                        )
                      }
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="home">Home</option>
                      <option value="mobile">Mobile</option>
                      <option value="office">Office</option>
                    </select>
                  </div>
                </div>
              </div> */}
              <div className="col-md-12">
                <div onClick={handleInputClick} onFocus={handleInputFocus}>
                  <PhoneInput
                    country={"us"}
                    enableSearch={true}
                    countryCodeEditable={false}
                    inputClass="phoneNumberInput w-100"
                    placeholder="Enter phone no."
                    // value={formFieldValues[element.fieldType] || ""}
                    onChange={(value) =>
                      handleFormFieldChange(element.fieldType, value)
                    }
                    className="form-group"
                    style={{ width: "100%" }}
                    disabled
                  />
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  };

  /**
   * Render personalized form elements (with drag handles and editing)
   * @param {Object} element - Element to render
   * @param {number} index - Index of element
   * @returns {JSX.Element|null} Rendered element or null
   */
  const renderFormElement = (element, index) => {
    if (!element) return null;

    return (
      // <Draggable
      //   key={element.id || `fallback_${index}`}
      //   position={dragPositions[element.id] || { x: 0, y: 0 }}
      //   onDrag={(e, data) => handleElementDrag(e, data, element.id)}
      //   onStop={(e, data) => handleElementDragStop(e, data, element.id)}
      //   axis="y"
      //   handle=".drag-handle"
      // >
      //   <div
      //     className="draggable-element"
      //     style={{
      //       marginBottom: "20px",
      //       border: "1px solid #e0e0e0",
      //       padding: "15px",
      //       borderRadius: "8px",
      //       position: "relative",
      //     }}
      //   >
      //     {/* Drag Handle with Controls */}
      //     <div
      //       className="d-flex justify-content-between align-items-center"
      //       style={{
      //         padding: "5px",
      //         background: "#f5f5f5",
      //         marginBottom: "10px",
      //         borderRadius: "4px",
      //       }}
      //     >
      //       <div
      //         className="drag-handle"
      //         style={{
      //           cursor: "move",
      //           flex: 1,
      //           textAlign: "left",
      //         }}
      //       >
      //          <img
      //                           src={DraggableIcon}
      //                           alt="Drag"
      //                           className="drag-icon"
      //                         />
      //          {element.type.charAt(0).toUpperCase() + element.type.slice(1)}
      //       </div>

      //       {/* Three-Dot Menu */}
      //       <div className="dropdown">
      //         <button
      //           type="button"
      //           className="btn btn-sm"
      //           data-bs-toggle="dropdown"
      //           aria-expanded="false"
      //           style={{
      //             border: "none",
      //             background: "transparent",
      //             fontSize: "18px",
      //             lineHeight: "1",
      //             color: "#666",
      //           }}
      //         >
      //           ⋮
      //         </button>
      //         <ul className="dropdown-menu dropdown-menu-end">
      //           <li>
      //             <button
      //               type="button"
      //               className="dropdown-item text-danger"
      //               onClick={() => deletePersonalizedElement(element.id)}
      //             >
      //               <img src={Delete} />
      //               Delete
      //             </button>
      //           </li>
      //         </ul>
      //       </div>
      //     </div>

      //     {/* Element-specific rendering */}
      //     {renderElementContent(element)}
      //   </div>
      // </Draggable>
      <Draggable
        key={element.id || `fallback_${index}`}
        position={dragPositions[element.id] || { x: 0, y: 0 }}
        onDrag={(e, data) => handleElementDrag(e, data, element.id)}
        onStop={(e, data) => handleElementDragStop(e, data, element.id)}
        axis="y"
        handle=".quick-build-drag-handle"
      >
        <div className="draggable-group mb-3 px-4 py-2 rounded position-relative">
          {/* Dropdown menu */}
          <div className="dropdown position-absolute top-0 end-0 mt-2 dropdown-inside-input">
            <button
              className="btn p-0"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span style={{ fontSize: "20px", lineHeight: 1 }}>⋮</span>
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => deletePersonalizedElement(element.id)}
                >
                  <img src={Delete} className="mx-2" alt="Delete" />
                  Delete
                </button>
              </li>
            </ul>
          </div>

          {/* Drag Handle */}
          <div className="quick-build-drag-handle mb-2">
            <img src={DraggableIcon} alt="Drag" className="drag-icon" />
          </div>

          {/* Field Rendered Content */}
          {renderElementContent(element)}
        </div>
      </Draggable>
    );
  };

  /**
   * Render the content of a form element based on its type
   * @param {Object} element - Element to render content for
   * @returns {JSX.Element} Rendered element content
   */
  const renderElementContent = (element) => {
    switch (element.type) {
      case "heading":
        return (
          <div className="form-group">
            <input
              type="text"
              value={element.customText}
              onChange={(e) =>
                updateElementProperty(element.id, "customText", e.target.value)
              }
              placeholder="Enter heading text here"
              className="form-control"
            />
          </div>
        );

      case "line":
        return (
          <div>
            <h6>Divider Line</h6>
            <hr
              style={{ borderTopColor: "var(--border_color)", opacity: "1" }}
            />
          </div>
        );

      case "paragraph":
        return (
          <div className="form-group">
            <input
              type="text"
              value={element.customText}
              onChange={(e) =>
                updateElementProperty(element.id, "customText", e.target.value)
              }
              placeholder="Enter paragraph text here"
              className="form-control"
              readOnly
            />
            {/* <p>{element.customText}</p> */}
          </div>
        );

      case "list":
        return (
          <div>
            <h5>List</h5>
            {element.options.map((option, optionIndex) => (
              <div key={optionIndex} className="d-flex align-items-center mb-2">
                <span>•</span>
                <input
                  type="text"
                  value={option}
                  onChange={(e) =>
                    updateElementOption(element.id, optionIndex, e.target.value)
                  }
                  placeholder="Enter bullet point text"
                  className="form-control"
                />
                <div className="d-flex justify-content-end align-items-center mt-2"></div>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => addOptionToElement(element.id)}
            >
              + Add
            </button>
          </div>
        );

      case "input":
        return (
          // <div>
          //   {element.fieldType === "phone_number" ||
          //   element.fieldType === "contact_no" ? (
          //     <div className="row">
          //       <div className="col-md-4">
          //         <select className="form-select" style={{ border: "0" }}>
          //           <option value="" disabled>
          //             Select
          //           </option>
          //           <option value="home">Home</option>
          //           <option value="mobile">Mobile</option>
          //           <option value="office">Office</option>
          //         </select>
          //       </div>
          //       <div className="col-md-8">
          //         <PhoneInput
          //           country={"us"}
          //           enableSearch={true}
          //           countryCodeEditable={false}
          //           inputClass="phoneNumberInput"
          //           placeholder="Enter phone no."
          //         />
          //       </div>
          //     </div>
          //   ) : (
          //     <FormInput
          //       type="text"
          //       label="Input Text"
          //       placeholder={element.placeholder || "Enter placeholder here"}
          //       value={formFieldValues[element.id] || ""}
          //       onChange={(e) =>
          //         handleFormFieldChange(element.id, e.target.value)
          //       }
          //     />
          //   )}

          //   <div className="d-flex justify-content-between align-items-center mt-2">
          //     <select
          //       value={element.fieldType}
          //       onChange={(e) =>
          //         updateElementProperty(element.id, "fieldType", e.target.value)
          //       }
          //       className="form-select"
          //       style={{ width: "auto" }}
          //     >
          //       <option value="">Field Type</option>
          //       {FIELD_TYPE_OPTIONS.map((option) => (
          //         <option key={option.value} value={option.value}>
          //           {option.label}
          //         </option>
          //       ))}
          //     </select>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div>
          // </div>

          // <div>
          //   <div className="d-flex justify-content-between align-items-center mb-2">
          //     <h6 className="mb-0">
          //       {element.fieldType === "phone_number" ||
          //       element.fieldType === "contact_no"
          //         ? "Phone Number"
          //         : "Input Text"}
          //     </h6>
          //     <div className="form-check d-flex align-items-center">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input me-1"
          //         id={`mandatory-${element.id}`}
          //       />
          //       <label
          //         className="form-check-label small text-muted"
          //         htmlFor={`mandatory-${element.id}`}
          //       >
          //         Mandatory
          //       </label>
          //     </div>
          //   </div>

          //   {element.fieldType === "phone_number" ||
          //   element.fieldType === "contact_no" ? (
          //     <div className="row">
          //       <div className="col-md-4">
          //         <select className="form-select" style={{ border: "0" }}>
          //           <option value="" disabled>
          //             Select
          //           </option>
          //           <option value="home">Home</option>
          //           <option value="mobile">Mobile</option>
          //           <option value="office">Office</option>
          //         </select>
          //       </div>
          //       <div className="col-md-8">
          //         <PhoneInput
          //           country={"us"}
          //           enableSearch={true}
          //           countryCodeEditable={false}
          //           inputClass="phoneNumberInput"
          //           placeholder="Enter phone no."
          //         />
          //       </div>
          //     </div>
          //   ) : (
          //     <FormInput
          //       type="text"
          //       label=""
          //       placeholder={element.placeholder || "Enter placeholder here"}
          //       value={formFieldValues[element.id] || ""}
          //       onChange={(e) =>
          //         handleFormFieldChange(element.id, e.target.value)
          //       }
          //     />
          //   )}

          //   <div className="d-flex justify-content-start align-items-center mt-2">
          //     <select
          //       value={element.fieldType}
          //       onChange={(e) =>
          //         updateElementProperty(element.id, "fieldType", e.target.value)
          //       }
          //       className="form-select"
          //       style={{ width: "auto" }}
          //     >
          //       <option value="">Field Type</option>
          //       {FIELD_TYPE_OPTIONS.map((option) => (
          //         <option key={option.value} value={option.value}>
          //           {option.label}
          //         </option>
          //       ))}
          //     </select>
          //   </div>
          // </div>

          <div className="p-2 rounded form-group">
            {/* Heading */}
            <div className="d-flex justify-content-between align-items-center mb-1">
              <label className="mb-0">
                {element.fieldType === "phone_number" ||
                element.fieldType === "contact_no"
                  ? "Phone Number"
                  : "Input Text"}
              </label>
            </div>

            {/* Main Field Row */}
            <div className="d-flex align-items-center gap-2">
              {/* Input / Phone Field */}
              <div className="flex-grow-1">
                {element.fieldType === "phone_number" ||
                element.fieldType === "contact_no" ? (
                  <PhoneInput
                    country={"us"}
                    enableSearch={true}
                    countryCodeEditable={false}
                    inputClass="form-control w-100"
                    placeholder="Enter placeholder here"
                    disabled
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    placeholder={
                      element.placeholder || "Enter placeholder here"
                    }
                    value={formFieldValues[element.id] || ""}
                    onChange={(e) =>
                      handleFormFieldChange(element.id, e.target.value)
                    }
                    readOnly
                  />
                )}
              </div>

              {/* Field Type dropdown */}
              <div className="d-flex align-items-center">
                <label className="me-1 mb-0 small text-muted">Field Type</label>
                <select
                  value={element.fieldType}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "fieldType",
                      e.target.value
                    )
                  }
                  className="form-select form-select-sm"
                  style={{ width: "120px" }}
                  readOnly
                >
                  <option value="">Field Type</option>
                  {FIELD_TYPE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Mandatory checkbox */}
              <div className="d-flex align-items-center ms-2">
                <label className="me-1 mb-0 small text-muted">Mandatory</label>
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input"
                  id={`mandatory-${element.id}`}
                  readOnly
                />
              </div>
            </div>
          </div>
        );

      case "textarea":
        return (
          // <div>
          //   <h6>Textarea</h6>
          //   <textarea
          //     className="globalTextArea form-control"
          //     placeholder="Enter placeholder here"
          //     value={formFieldValues[element.id] || ""}
          //     onChange={(e) =>
          //       handleFormFieldChange(element.id, e.target.value)
          //     }
          //   ></textarea>
          //   <div className="form-check mt-2">
          //     <input
          //       type="checkbox"
          //       checked={element.isMandatory}
          //       onChange={(e) =>
          //         updateElementProperty(
          //           element.id,
          //           "isMandatory",
          //           e.target.checked
          //         )
          //       }
          //       className="form-check-input"
          //     />
          //     <label className="form-check-label">Mandatory</label>
          //   </div>
          // </div>

          <div className="form-group">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">Textarea</label>
              <div className="form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                  readOnly
                />
                <label
                  className="form-check-label small text-muted"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            <textarea
              className="globalTextArea form-control"
              placeholder="Enter placeholder here"
              value={formFieldValues[element.id] || ""}
              onChange={(e) =>
                handleFormFieldChange(element.id, e.target.value)
              }
              readOnly
            ></textarea>
          </div>
        );

      case "radio":
        return (
          // <div>
          //   <h6>Radiogroup</h6>
          //   {element.options.map((option, optionIndex) => (
          //     <div key={optionIndex} className="d-flex align-items-center mb-2">
          //       <input type="radio" className="me-2" disabled />
          //       <input
          //         type="text"
          //         value={option}
          //         onChange={(e) =>
          //           updateElementOption(element.id, optionIndex, e.target.value)
          //         }
          //         placeholder="Enter radio option"
          //         className="form-control"
          //       />
          //       <button
          //         type="button"
          //         className="btn btn-sm ms-2"
          //         onClick={() => deleteElementOption(element.id, optionIndex)}
          //       >
          //         <img src={Delete} />
          //       </button>
          //     </div>
          //   ))}
          //   <div className="d-flex justify-content-between align-items-center mt-2">
          //     <button
          //       type="button"
          //       className="btn btn-sm btn-primary"
          //       onClick={() => addOptionToElement(element.id)}
          //     >
          //       + Add
          //     </button>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div>
          // </div>

          // <div>
          //   <div className="d-flex justify-content-between align-items-center mb-2">
          //     <h6 className="mb-0">Radiogroup</h6>
          //     <div className="form-check d-flex align-items-center">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input me-1"
          //         id={`mandatory-${element.id}`}
          //       />
          //       <label
          //         className="form-check-label small text-muted"
          //         htmlFor={`mandatory-${element.id}`}
          //       >
          //         Mandatory
          //       </label>
          //     </div>
          //   </div>

          //   {element.options.map((option, optionIndex) => (
          //     <div key={optionIndex} className="d-flex align-items-center mb-2">
          //       <input type="radio" className="me-2" disabled />
          //       <input
          //         type="text"
          //         value={option}
          //         onChange={(e) =>
          //           updateElementOption(element.id, optionIndex, e.target.value)
          //         }
          //         placeholder="Enter radio option"
          //         className="form-control"
          //       />
          //       <button
          //         type="button"
          //         className="btn btn-sm ms-2"
          //         onClick={() => deleteElementOption(element.id, optionIndex)}
          //       >
          //         <img src={Delete} alt="Delete" />
          //       </button>
          //     </div>
          //   ))}

          //   <div className="d-flex justify-content-end align-items-center mt-2">
          //     <button
          //       type="button"
          //       className="btn btn-outline-primary btn-sm"
          //       onClick={() => addOptionToElement(element.id)}
          //     >
          //       + Add
          //     </button>
          //   </div>
          // </div>
          <div className="form-group p-3 border rounded bg-white">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">Radiogroup</label>
              <div
                className="form-check d-flex align-items-center"
                style={{ marginRight: "20px" }}
              >
                <input
                  type="checkbox"
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  readOnly
                />
                <label
                  className="form-check-label small text-muted"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            <div className="row">
              {element.options.map((option, index) => (
                <div key={index} className="col-md-6 mb-2">
                  <div className="d-flex align-items-center">
                    <input
                      type="radio"
                      className="form-check-input me-2"
                      name={`radio-${element.id}`} // enables proper selection
                      checked={element.selectedOption === index}
                      onChange={() =>
                        updateElementProperty(
                          element.id,
                          "selectedOption",
                          index
                        )
                      }
                      readOnly
                    />
                    <input
                      type="text"
                      className="form-control me-2"
                      value={option}
                      placeholder="Enter radio option"
                      onChange={(e) =>
                        updateElementOption(element.id, index, e.target.value)
                      }
                      readOnly
                    />
                    {element.options.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-sm text-danger"
                        onClick={() => deleteElementOption(element.id, index)}
                        title="Delete option"
                      >
                        <img src={Delete} />
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => addOptionToElement(element.id)}
              >
                + Add
              </button>
            </div>
          </div>
        );

      case "checkbox":
        return (
          // <div>
          //   <h6>Checkboxes</h6>
          //   {element.options.map((option, optionIndex) => (
          //     <div key={optionIndex} className="d-flex align-items-center mb-2">
          //       <input type="checkbox" className="me-2" disabled />
          //       <input
          //         type="text"
          //         value={option}
          //         onChange={(e) =>
          //           updateElementOption(element.id, optionIndex, e.target.value)
          //         }
          //         placeholder="Enter checkbox option"
          //         className="form-control"
          //       />
          //       <button
          //         type="button"
          //         className="btn btn-sm ms-2"
          //         onClick={() => deleteElementOption(element.id, optionIndex)}
          //       >
          //         <img src={Delete} />
          //       </button>
          //     </div>
          //   ))}
          //   {/* <div className="d-flex justify-content-between align-items-center mt-2">
          //     <button
          //       type="button"
          //       className="btn btn-sm btn-primary"
          //       onClick={() => addOptionToElement(element.id)}
          //     >
          //       + Add
          //     </button>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div> */}

          // </div>

          // <div>
          //   <div className="d-flex justify-content-between align-items-center mb-2">
          //     <h6 className="mb-0">Checkboxes</h6>

          //     <div className="form-check d-flex align-items-center">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input me-1"
          //         id={`mandatory-${element.id}`}
          //       />
          //       <label
          //         className="form-check-label small text-muted mr-3"
          //         htmlFor={`mandatory-${element.id}`}
          //       >
          //         Mandatory
          //       </label>
          //     </div>
          //   </div>

          //   {element.options.map((option, optionIndex) => (
          //     <div key={optionIndex} className="d-flex align-items-center mb-2">
          //       <input type="checkbox" className="me-2" disabled />

          //       <input
          //         type="text"
          //         value={option}
          //         onChange={(e) =>
          //           updateElementOption(element.id, optionIndex, e.target.value)
          //         }
          //         placeholder="Enter checkbox option"
          //         className="form-control"
          //       />

          //       <button
          //         type="button"
          //         className="btn btn-sm ms-2"
          //         onClick={() => deleteElementOption(element.id, optionIndex)}
          //       >
          //         <img src={Delete} alt="Delete" />
          //       </button>
          //     </div>
          //   ))}

          //   <div className="d-flex justify-content-end align-items-center mt-2">
          //     <button
          //       type="button"
          //       className="btn btn-outline-primary btn-sm"
          //       onClick={() => addOptionToElement(element.id)}
          //     >
          //       + Add
          //     </button>
          //   </div>
          // </div>

          <div>
            <div className="form-group d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">Checkboxes</label>

              <div className="form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                  readOnly
                />
                <label
                  className="form-check-label small text-muted mr-3"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            {element.options.map((option, optionIndex) => (
              <div key={optionIndex} className="d-flex align-items-center mb-2">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={element.selectedOptions?.includes(optionIndex)}
                  onChange={(e) => {
                    const updatedSelections = element.selectedOptions || [];
                    const isChecked = e.target.checked;

                    const newSelections = isChecked
                      ? [...updatedSelections, optionIndex]
                      : updatedSelections.filter((i) => i !== optionIndex);

                    updateElementProperty(
                      element.id,
                      "selectedOptions",
                      newSelections
                    );
                  }}
                  readOnly
                />

                <input
                  type="text"
                  value={option}
                  onChange={(e) =>
                    updateElementOption(element.id, optionIndex, e.target.value)
                  }
                  placeholder="Enter checkbox option"
                  className="form-control"
                  readOnly
                />

                <button
                  type="button"
                  className="btn btn-sm ms-2"
                  onClick={() => deleteElementOption(element.id, optionIndex)}
                >
                  <img src={Delete} alt="Delete" />
                </button>
              </div>
            ))}

            <div className="d-flex justify-content-end align-items-center mt-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => addOptionToElement(element.id)}
              >
                + Add
              </button>
            </div>
          </div>
        );

      case "dropdown":
        return (
          // <div>
          //   <h6>Dropdown</h6>
          //   <select className="form-select mb-2" disabled>
          //     {element.options.map((option, optionIndex) => (
          //       <option key={optionIndex}>{option}</option>
          //     ))}
          //   </select>
          //   {element.options.map((option, optionIndex) => (
          //     <div key={optionIndex} className="d-flex align-items-center mb-2">
          //       <input
          //         type="text"
          //         value={option}
          //         onChange={(e) =>
          //           updateElementOption(element.id, optionIndex, e.target.value)
          //         }
          //         placeholder="Enter dropdown option"
          //         className="form-control"
          //       />
          //       <button
          //         type="button"
          //         className="btn btn-sm ms-2"
          //         onClick={() => deleteElementOption(element.id, optionIndex)}
          //       >
          //         <img src={Delete} />
          //       </button>
          //     </div>
          //   ))}
          //   <div className="d-flex justify-content-between align-items-center mt-2">
          //     <button
          //       type="button"
          //       className="btn btn-sm btn-primary"
          //       onClick={() => addOptionToElement(element.id)}
          //     >
          //       + Add
          //     </button>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div>
          // </div>

          <div>
            <div className="form-group d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">Dropdown</label>
              <div className="form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                  readOnly
                />
                <label
                  className="form-check-label small text-muted"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            <select className="form-select mb-2" disabled>
              {element.options.map((option, optionIndex) => (
                <option key={optionIndex}>{option}</option>
              ))}
            </select>

            {element.options.map((option, optionIndex) => (
              <div key={optionIndex} className="d-flex align-items-center mb-2">
                <input
                  type="text"
                  value={option}
                  onChange={(e) =>
                    updateElementOption(element.id, optionIndex, e.target.value)
                  }
                  placeholder="Enter dropdown option"
                  className="form-control"
                  readOnly
                />
                <button
                  type="button"
                  className="btn btn-sm ms-2"
                  onClick={() => deleteElementOption(element.id, optionIndex)}
                >
                  <img src={Delete} alt="Delete" />
                </button>
              </div>
            ))}

            <div className="d-flex justify-content-end align-items-center mt-2">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => addOptionToElement(element.id)}
              >
                + Add
              </button>
            </div>
          </div>
        );

      case "date":
        return (
          // <div>
          //   <h6>Date Picker</h6>
          //   <div
          //     style={{
          //       display: "flex",
          //       alignItems: "center",
          //       gap: "10px",
          //       marginBottom: "10px",
          //     }}
          //   >
          //     <span>📅</span>
          //     <DatePicker
          //       dateFormat="MM/dd/yyyy"
          //       placeholderText="MM/dd/yyyy"
          //       className="dobInput profile form-control"
          //       disabled
          //     />
          //   </div>
          //   <div className="d-flex justify-content-between align-items-center">
          //     <select
          //       value={element.fieldType}
          //       onChange={(e) =>
          //         updateElementProperty(element.id, "fieldType", e.target.value)
          //       }
          //       className="form-select"
          //       style={{ width: "auto" }}
          //     >
          //       <option value="">Field Type</option>
          //       <option value="date_picker">Date Picker</option>
          //     </select>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div>
          // </div>

          <div>
            <div className="form-group d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">Date Picker</label>
              <div className="form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                  readOnly
                />
                <label
                  className="form-check-label small text-muted"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2 mb-3">
              <span>📅</span>
              <DatePicker
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/dd/yyyy"
                className="dobInput profile form-control"
                disabled
              />
            </div>

            <div className="form-groupd-flex justify-content-start align-items-center mt-2">
              <select
                value={element.fieldType}
                onChange={(e) =>
                  updateElementProperty(element.id, "fieldType", e.target.value)
                }
                className="form-select form-control"
                style={{ width: "auto" }}
              >
                <option value="">Field Type</option>
                <option value="date_picker">Date Picker</option>
              </select>
            </div>
          </div>
        );

      case "upload":
        return (
          // <div>
          //   <h6>File Uploader</h6>
          //   <div
          //     style={{
          //       border: "2px dashed #ccc",
          //       padding: "20px",
          //       textAlign: "center",
          //       marginBottom: "10px",
          //     }}
          //   >
          //     <button type="button" className="btn btn-outline-secondary">
          //       Browse
          //     </button>
          //     <div
          //       style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}
          //     >
          //       Enter upload instruction here
          //     </div>
          //   </div>
          //   <div className="d-flex justify-content-between align-items-center">
          //     <select
          //       value={element.fieldType}
          //       onChange={(e) =>
          //         updateElementProperty(element.id, "fieldType", e.target.value)
          //       }
          //       className="form-select"
          //       style={{ width: "auto" }}
          //     >
          //       <option value="">Field Type</option>
          //       <option value="file_uploader">File Uploader</option>
          //     </select>
          //     <div className="form-check">
          //       <input
          //         type="checkbox"
          //         checked={element.isMandatory}
          //         onChange={(e) =>
          //           updateElementProperty(
          //             element.id,
          //             "isMandatory",
          //             e.target.checked
          //           )
          //         }
          //         className="form-check-input"
          //       />
          //       <label className="form-check-label">Mandatory</label>
          //     </div>
          //   </div>
          // </div>
          <div>
            <div className="form-group d-flex justify-content-between align-items-center mb-2">
              <label className="mb-0">File Uploader</label>
              <div className="form-check d-flex align-items-center">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input me-1"
                  id={`mandatory-${element.id}`}
                />
                <label
                  className="form-check-label small text-muted"
                  htmlFor={`mandatory-${element.id}`}
                >
                  Mandatory
                </label>
              </div>
            </div>

            <div
              style={{
                border: "2px dashed #ccc",
                padding: "20px",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              <button type="button" className="btn btn-outline-secondary">
                Browse
              </button>
              <div
                style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}
              >
                Enter upload instruction here
              </div>
            </div>

            <div className="d-flex justify-content-start align-items-center mt-2">
              <select
                value={element.fieldType}
                onChange={(e) =>
                  updateElementProperty(element.id, "fieldType", e.target.value)
                }
                className="form-select"
                style={{ width: "auto" }}
              >
                <option value="">Field Type</option>
                <option value="file_uploader">File Uploader</option>
              </select>
            </div>
          </div>
        );

      case "link":
        return (
          <div className="form-group">
            <label>Link</label>
            <input
              type="url"
              className="form-control mb-2"
              placeholder="Enter hyperlink URL"
              value={element.linkUrl || ""}
              onChange={(e) =>
                updateElementProperty(element.id, "linkUrl", e.target.value)
              }
            />
            <div className="d-flex justify-content-between align-items-center">
              <select
                value={element.fieldType}
                onChange={(e) =>
                  updateElementProperty(element.id, "fieldType", e.target.value)
                }
                className="form-select form-control"
                style={{ width: "auto" }}
              >
                <option value="">Field Type</option>
                {FIELD_TYPE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <div className="form-check">
                <input
                  type="checkbox"
                  checked={element.isMandatory}
                  onChange={(e) =>
                    updateElementProperty(
                      element.id,
                      "isMandatory",
                      e.target.checked
                    )
                  }
                  className="form-check-input"
                />
                <label className="form-check-label">Mandatory</label>
              </div>
            </div>
          </div>
        );

      default:
        return <div>Unknown element type</div>;
    }
  };

  // ===============================
  // 14. USEEFFECT HOOKS
  // ===============================

  /**
   * Group Quick Build elements when they change
   */
  useEffect(() => {
    const safeQuickBuildElements = quickBuildElements.filter(
      (el) => el != null
    );

    if (safeQuickBuildElements.length > 0) {
      const grouped = groupElements(safeQuickBuildElements);
      // Only update if the structure actually changed
      setElementGroups((prevGroups) => {
        const prevIds = prevGroups.map((g) => g.id).sort();
        const newIds = grouped.map((g) => g.id).sort();

        if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
          return grouped;
        }
        return prevGroups;
      });
    } else {
      setElementGroups([]);
    }
  }, [quickBuildElements]);

  // Prefill from card_form_builder data
  useEffect(() => {
    if (prefillType === "card_form_builder" && cardFormBuilderData) {
      const { elements, checkedIds } =
        mapCardFormBuilderToQuickBuild(cardFormBuilderData);

      // Update preDefineItems to mark appropriate items as checked
      setPreDefineItems((prevItems) =>
        prevItems.map((item) => ({
          ...item,
          checked: checkedIds.includes(item.id),
        }))
      );

      // Set quick build elements
      setQuickBuildElements(elements);

      // Show submit button and set active tab
      if (elements.length > 0) {
        setShowSubmitButton(true);
        setActiveTab("quickBuild");
      }
    }
  }, [prefillType, cardFormBuilderData]);

  /**
   * Load existing form data when component mounts with an ID
   */
  // useEffect(() => {
  //   if (id) {
  //     setLoading(true);
  //     getFormData();
  //   }
  // }, []);

  useEffect(() => {
    if (cardFormBuilderData && cardFormBuilderData.length > 0) {
      // Use passed data directly
      const quickFields = cardFormBuilderData.filter((f) => f.isPreDefined);
      const personalizedFields = cardFormBuilderData.filter(
        (f) => !f.isPreDefined
      );

      setQuickBuildElements(quickFields);
      setPersonalizedBuildElements(personalizedFields);
      setShowSubmitButton(true);

      // Optional: set predefined checkboxes
      setPreDefineItems((prev) =>
        prev.map((item) =>
          cardFormBuilderData.some((f) => f.fieldType === item.field_type)
            ? { ...item, checked: true }
            : item
        )
      );

      // Set tab
      // if (personalizedFields.length > 0) {
      //   setActiveTab("personalizedBuild");
      // } else if (quickFields.length > 0) {
      //   setActiveTab("quickBuild");
      // } else {
      //   setActiveTab("title");
      // }
    } else if (id) {
      // If no passed data, call API
      getFormData();
    }
  }, []);

  // ===============================
  // 15. MAIN COMPONENT JSX
  // ===============================

  // intro.js walkthrough
  const [leadFunctionWalkthrough, setLeadFunctionWalkthrough] = useState(
    localStorage.getItem("leadFunctionWalkthroughDone") || false
  );
  const startWalkthrough = () => {
    introJs()
      .setOptions({
        showProgress: false,
        showBullets: false,
        exitOnOverlayClick: false,
        tooltipPosition: "auto",
        nextLabel: "Next",
        prevLabel: "Back",
        doneLabel: "Done",
      })
      .oncomplete(() => {
        localStorage.setItem("leadFunctionWalkthroughDone", "true");
        setLeadFunctionWalkthrough(true);
      })
      .onexit(() => {
        localStorage.setItem("leadFunctionWalkthroughDone", "true");
        setLeadFunctionWalkthrough(true);
      })
      .start();
  };
  useEffect(() => {
    if (!leadFunctionWalkthrough) {
      setTimeout(() => {
        startWalkthrough();
      }, 1000); // Give time to render sidebar items
    }
  }, []);

  return (
    <>
      {!loading ? (
        <>
          <div className="">
            <div className="mainWrapper heading">
              {/* Breadcrumb Navigation */}
              <h1>
                <Link to="/" className="function-link">
                  Functions
                </Link>
                {` > `}
                <Link
                  to="/function/formBuilderListing"
                  className="function-link"
                >
                  Lead Builder
                </Link>
                {` > Create Lead Builder`}
              </h1>

              {/* Top Action Bar */}
              <div className="d-flex align-items-center justify-content-between mb-3 mobileViewWrapper">
                <Button
                  variant="primary"
                  className={`save-button ${
                    formName.trim() ? "enabled" : "disabled"
                  }`}
                  onClick={handleSubmit}
                  disabled={!formName.trim()}
                >
                  Save Changes
                </Button>
              </div>
            </div>

            <div className="row">
              {/* Left Panel - Form Builder Tools */}
              <div className="col-md-4">
                <div className="form-builder-wrapper">
                  {/* Step-by-Step Navigation */}
                  {/* Step-by-Step Navigation */}
                  <div className="step-navigation">
                    {/* Step 1: Lead Builder Title */}
                    <div
                      className={`step-item ${
                        activeTab === "title" ? "active" : ""
                      } ${formName.trim() ? "completed" : ""}`}
                      data-intro={`
                        <h3>Step 1: Lead Builder Title</h3>
                        <p>Start by entering a title for your form. This helps you identify and organize your form easily.</p>
                      `}
                      data-step={1}
                    >
                      <div
                        className="step-header"
                        onClick={() => setActiveTab("title")}
                      >
                        <div className="step-number">1</div>
                        <div className="step-content">
                          <p className="step-title">Lead Builder Title</p>
                        </div>
                        {activeTab === "title" && (
                          <div className="step-arrow">
                            <img src={StepArrow} alt="arrow" />
                          </div>
                        )}
                      </div>
                      {/* No expanded content for title step */}
                    </div>

                    {/* Step 2: Quick Build Form Elements */}
                    <div
                      className={`step-item ${
                        activeTab === "quickBuild" ? "active" : ""
                      } ${quickBuildElements.length > 0 ? "completed" : ""}`}
                      data-intro={`
                        <h3>Step 2: Quick Build Form Elements</h3>
                        <p>Select predefined form elements to quickly build your form. These are commonly used fields like name, email, etc.</p>
                      `}
                      data-step={2}
                    >
                      <div
                        className="step-header"
                        onClick={() =>
                          formName.trim() && setActiveTab("quickBuild")
                        }
                        style={{
                          opacity: formName.trim() ? 1 : 0.5,
                          pointerEvents: formName.trim() ? "auto" : "none",
                        }}
                      >
                        <div className="step-number">2</div>
                        <div className="step-content">
                          <p className="step-title">
                            Quick Build Form Elements
                          </p>
                        </div>
                        {activeTab === "quickBuild" && (
                          <div className="step-arrow">
                            <img src={StepArrow} alt="arrow" />
                          </div>
                        )}
                      </div>

                      {/* Quick Build Content */}
                      <div
                        className={`step-expanded-content ${
                          activeTab === "quickBuild" ? "show" : ""
                        }`}
                      >
                        <div className="quick-build-content">
                          <div className="quick-build-grid">
                            {preDefineItems.map((item) => (
                              <div
                                key={item.id}
                                className={`quick-build-item ${
                                  item.checked ? "selected" : ""
                                }`}
                                onClick={() => toggleCheckbox(item.id)}
                              >
                                <div className="quick-build-checkbox"></div>
                                <div className="quick-build-icon">
                                  {item.icon}
                                </div>
                                <p className="quick-build-label">
                                  {item.label}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Step 3: Personalized Build Form Elements */}
                    <div
                      className={`step-item ${
                        activeTab === "personalizedBuild" ? "active" : ""
                      } ${
                        personalizedBuildElements.length > 0 ? "completed" : ""
                      }`}
                      data-intro={`
                        <h3>Step 3: Personalized Build Form Elements</h3>
                        <p>Create and add custom form fields tailored to your unique needs. This gives you full control over your form structure.</p>
                      `}
                      data-step={3}
                    >
                      <div
                        className="step-header"
                        onClick={() =>
                          formName.trim() && setActiveTab("personalizedBuild")
                        }
                        style={{
                          opacity: formName.trim() ? 1 : 0.5,
                          pointerEvents: formName.trim() ? "auto" : "none",
                        }}
                      >
                        <div className="step-number">3</div>
                        <div className="step-content">
                          <p className="step-title">
                            Personalized Build Form Elements
                          </p>
                        </div>
                        {activeTab === "personalizedBuild" && (
                          <div className="step-arrow">
                            <img src={StepArrow} alt="arrow" />
                          </div>
                        )}
                      </div>

                      {/* Personalized Build Content */}
                      {/* <div
                        className={`step-expanded-content ${
                          activeTab === "personalizedBuild" ? "show" : ""
                        }`}
                      >
                        <div className="personalized-build-content">
                          <div className="elements-grid">
                            <button
                              className="element-button element-heading"
                              onClick={() => addElement("heading", "Heading")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Heading} alt="Heading" />
                              </div>
                              <p className="element-label">Heading</p>
                            </button>

                            <button
                              className="element-button element-line"
                              onClick={() => addElement("line", "Line")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Line} alt="Divider Line" />
                              </div>
                              <p className="element-label">Divider Line</p>
                            </button>

                            <button
                              className="element-button element-paragraph"
                              onClick={() =>
                                addElement("paragraph", "Paragraph")
                              }
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Paragraph} alt="Paragraph" />
                              </div>
                              <p className="element-label">Paragraph</p>
                            </button>

                            <button
                              className="element-button element-list"
                              onClick={() =>
                                addElement("list", "List", ["Option 1"])
                              }
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={List} alt="List" />
                              </div>
                              <p className="element-label">List</p>
                            </button>

                            <button
                              className="element-button element-input"
                              onClick={() => addElement("input", "Input Text")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={InputText} alt="Input Text" />
                              </div>
                              <p className="element-label">Input Text</p>
                            </button>

                            <button
                              className="element-button element-textarea"
                              onClick={() => addElement("textarea", "Textarea")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Textarea} alt="Textarea" />
                              </div>
                              <p className="element-label">Textarea</p>
                            </button>

                            <button
                              className="element-button element-radio"
                              onClick={() =>
                                addElement("radio", "Radio Button", [
                                  "Option 1",
                                  "Option 2",
                                ])
                              }
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={RadioGroup} alt="Radio Group" />
                              </div>
                              <p className="element-label">Radiogroup</p>
                            </button>

                            <button
                              className="element-button element-checkbox"
                              onClick={() =>
                                addElement("checkbox", "Checkbox", ["Option 1"])
                              }
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Checkbox} alt="Checkbox" />
                              </div>
                              <p className="element-label">Checkbox</p>
                            </button>

                            <button
                              className="element-button element-dropdown"
                              onClick={() =>
                                addElement("dropdown", "Dropdown", [
                                  "Option 1",
                                  "Option 2",
                                ])
                              }
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Dropdown} alt="Dropdown" />
                              </div>
                              <p className="element-label">Dropdown</p>
                            </button>

                            <button
                              className="element-button element-upload"
                              onClick={() => addElement("upload", "Upload")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={Upload} alt="File Uploader" />
                              </div>
                              <p className="element-label">File Uploader</p>
                            </button>

                            <button
                              className="element-button element-date"
                              onClick={() => addElement("date", "Date")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={CalendarIcon} alt="Date Picker" />
                              </div>
                              <p className="element-label">Date Picker</p>
                            </button>

                            <button
                              className="element-button element-link"
                              onClick={() => addElement("link", "Link")}
                              type="button"
                            >
                              <div className="element-icon-wrapper">
                                <img src={AddLink} alt="Link" />
                              </div>
                              <p className="element-label">Link</p>
                            </button>
                          </div>
                        </div>
                      </div> */}

                      <div
                        className={`step-expanded-content ${
                          activeTab === "personalizedBuild" ? "show" : ""
                        }`}
                      >
                        <div className="personalized-build-content">
                          <div className="elements-grid">
                            {/* Heading */}
                            <button
                              className="element-button element-heading"
                              onClick={() => addElement("heading", "Heading")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  <FaHeading />
                                </div>
                                <p className="element-label">Heading</p>
                              </div>
                            </button>

                            {/* Divider Line */}
                            <button
                              className="element-button element-line"
                              onClick={() => addElement("line", "Line")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  <FaMinus />
                                </div>
                                <p className="element-label">Divider Line</p>
                              </div>
                            </button>

                            {/* Paragraph */}
                            <button
                              className="element-button element-paragraph"
                              onClick={() =>
                                addElement("paragraph", "Paragraph")
                              }
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaParagraph /> */}
                                  <img src={Paragraph} />
                                </div>
                                <p className="element-label">Paragraph</p>
                              </div>
                            </button>

                            {/* List */}
                            <button
                              className="element-button element-list"
                              onClick={() =>
                                addElement("list", "List", ["Option 1"])
                              }
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaList /> */}
                                  <img src={List} />
                                </div>
                                <p className="element-label">List</p>
                              </div>
                            </button>

                            {/* Input Text */}
                            <button
                              className="element-button element-input"
                              onClick={() => addElement("input", "Input Text")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaKeyboard /> */}
                                  <img src={InputText} />
                                </div>
                                <p className="element-label">Input Text</p>
                              </div>
                            </button>

                            {/* Textarea */}
                            <button
                              className="element-button element-textarea"
                              onClick={() => addElement("textarea", "Textarea")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaRegCommentDots /> */}
                                  <img src={Textarea} />
                                </div>
                                <p className="element-label">Textarea</p>
                              </div>
                            </button>

                            {/* Radio Group */}
                            <button
                              className="element-button element-radio"
                              onClick={() =>
                                addElement("radio", "Radio Button", [
                                  "Option 1",
                                  "Option 2",
                                ])
                              }
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaDotCircle /> */}
                                  <img src={RadioGroup} />
                                </div>
                                <p className="element-label">Radiogroup</p>
                              </div>
                            </button>

                            {/* Checkbox */}
                            <button
                              className="element-button element-checkbox"
                              onClick={() =>
                                addElement("checkbox", "Checkbox", ["Option 1"])
                              }
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaCheckSquare /> */}
                                  <img src={Checkbox} />
                                </div>
                                <p className="element-label">Checkbox</p>
                              </div>
                            </button>

                            {/* Dropdown */}
                            <button
                              className="element-button element-dropdown"
                              onClick={() =>
                                addElement("dropdown", "Dropdown", [
                                  "Option 1",
                                  "Option 2",
                                ])
                              }
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaChevronDown /> */}
                                  <img src={Dropdown} />
                                </div>
                                <p className="element-label">Dropdown</p>
                              </div>
                            </button>

                            {/* File Uploader */}
                            <button
                              className="element-button element-upload"
                              onClick={() => addElement("upload", "Upload")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaUpload /> */}
                                  <img src={Upload} />
                                </div>
                                <p className="element-label">File Uploader</p>
                              </div>
                            </button>

                            {/* Date Picker */}
                            <button
                              className="element-button element-date"
                              onClick={() => addElement("date", "Date")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaCalendarAlt /> */}
                                  <img src={CalendarIcon} />
                                </div>
                                <p className="element-label">Date Picker</p>
                              </div>
                            </button>

                            {/* Link */}
                            <button
                              className="element-button element-link"
                              onClick={() => addElement("link", "Link")}
                              type="button"
                            >
                              <div className="element-content">
                                <div className="element-icon-wrapper">
                                  {/* <FaLink /> */}
                                  <img src={AddLink} />
                                </div>
                                <p className="element-label">Link</p>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Panel - Form Preview */}
              <div className="col-md-8">
                <div className="form-builder-wrapper">
                  {/* Title Tab Content */}
                  {activeTab === "title" && (
                    <div className="fade-in">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0">Add Title</h5>
                        <div>
                          <Button
                            variant="link"
                            className="me-2 text-decoration-none"
                            onClick={handleBack}
                            style={{
                              color: "var(--blue-color)",
                            }}
                          >
                            {` < Back`}
                          </Button>
                          <Button
                            variant="outline-primary"
                            onClick={handleNext}
                            disabled={!formName.trim()}
                          >
                            {` Next >`}
                          </Button>
                        </div>
                      </div>

                      <FormInput
                        type="text"
                        label="Lead Builder Title"
                        placeholder="Enter Title"
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        error={errors}
                      />
                      {/* <Form.Check
                        type="switch"
                        label="Active Lead Builder"
                        checked={true}
                        onChange={() => {}}
                        className="mt-3"
                      /> */}
                    </div>
                  )}

                  {/* Quick Build Tab Content */}
                  {activeTab === "quickBuild" && (
                    <div className="fade-in">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                          <h5 className="mb-0">
                            Add Quick Build Form Elements
                          </h5>
                          <small className="small-text">
                            Turn on fields as per requirement
                          </small>
                        </div>

                        <div>
                          <Button
                            variant="link"
                            className="me-2 text-decoration-none"
                            onClick={handleBack}
                            style={{
                              color: "var(--blue-color)",
                            }}
                          >
                            {` < Back`}
                          </Button>
                          <Button
                            variant="outline-primary"
                            onClick={handleNext}
                          >
                            {` Next >`}
                          </Button>
                        </div>
                      </div>

                      {/* <div className="form-preview-wrapper p-4 bg-light rounded">
                        {elementGroups.length > 0 ? (
                          elementGroups.map((group, groupIndex) => (
                            <Draggable
                              key={`${group.id}-${group.elements
                                .map((e) => e.fieldType)
                                .join("-")}`}
                              position={
                                groupPositions[group.id] || { x: 0, y: 0 }
                              }
                              onDrag={(e, data) =>
                                handleDrag(e, data, group.id)
                              }
                              onStop={(e, data) =>
                                handleStop(e, data, group.id)
                              }
                              axis="y"
                              handle=".quick-build-drag-handle"
                            >
                              <div className="draggable-group mb-3 p-3 bg-white rounded border position-relative">
                                <div className="quick-build-drag-handle">
                                  <img
                                    src={DraggableIcon}
                                    alt="Drag"
                                    className="drag-icon"
                                  />
                                </div>
                                {group.type === "name-group" ? (
                                  <div className="row">
                                    <div className="col-md-6">
                                      {renderQuickBuildElement(
                                        group.elements[0],
                                        `${groupIndex}-0`
                                      )}
                                    </div>
                                    <div className="col-md-6">
                                      {renderQuickBuildElement(
                                        group.elements[1],
                                        `${groupIndex}-1`
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  group.elements.map((element, elementIndex) =>
                                    renderQuickBuildElement(
                                      element,
                                      `${groupIndex}-${elementIndex}`
                                    )
                                  )
                                )}
                              </div>
                            </Draggable>
                          ))
                        ) : (
                          <div className="text-center py-5 text-muted">
                            <i className="fas fa-plus-circle fa-3x mb-3"></i>
                            <p>
                              No elements selected. Choose elements from the
                              left panel.
                            </p>
                          </div>
                        )}
                      </div> */}

                      {elementGroups.map((group, groupIndex) => (
                        <Draggable
                          key={`${group.id}-${group.elements
                            .map((e) => e.fieldType)
                            .join("-")}`}
                          position={groupPositions[group.id] || { x: 0, y: 0 }}
                          onDrag={(e, data) => handleDrag(e, data, group.id)}
                          onStop={(e, data) => handleStop(e, data, group.id)}
                          axis="y"
                          handle=".quick-build-drag-handle"
                        >
                          <div
                            className={`draggable-group mb-3 px-4 py-2 rounded position-relative ${
                              group.elements.some(
                                (el) => el.fieldType === "location"
                              )
                                ? "border"
                                : ""
                            }`}
                          >
                            {/* Add the dropdown here */}
                            <div className="dropdown position-relative top-0 end-0 mt-2 dropdown-inside-input text-end">
                              <button
                                className="btn p-0"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <span
                                  style={{ fontSize: "20px", lineHeight: 1 }}
                                >
                                  ⋮
                                </span>
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => handleDeleteGroup(group.id)}
                                  >
                                    <img className="mx-3" src={Delete} />
                                    Delete
                                  </button>
                                </li>
                              </ul>
                            </div>

                            {/* Existing drag handle */}
                            <div className="quick-build-drag-handle">
                              <img
                                src={DraggableIcon}
                                alt="Drag"
                                className="drag-icon"
                              />
                            </div>

                            {/* Element rendering */}
                            {group.type === "name-group" ? (
                              <div className="row">
                                <div className="col-md-6">
                                  {renderQuickBuildElement(
                                    group.elements[0],
                                    `${groupIndex}-0`
                                  )}
                                </div>
                                <div className="col-md-6">
                                  {renderQuickBuildElement(
                                    group.elements[1],
                                    `${groupIndex}-1`
                                  )}
                                </div>
                              </div>
                            ) : (
                              group.elements.map((element, elementIndex) =>
                                renderQuickBuildElement(
                                  element,
                                  `${groupIndex}-${elementIndex}`
                                )
                              )
                            )}
                          </div>
                        </Draggable>
                      ))}
                    </div>
                  )}

                  {/* Personalized Build Tab Content */}
                  {activeTab === "personalizedBuild" && (
                    <div className="fade-in">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0">Personalized Form Preview</h5>
                        <div>
                          <Button
                            variant="link"
                            className="me-2 text-decoration-none"
                            onClick={handleBack}
                            style={{
                              color: "var(--blue-color)",
                            }}
                          >
                            {` < Back`}
                          </Button>
                          <Button variant="outline-primary" disabled={true}>
                            {` Next >`}
                          </Button>
                        </div>
                      </div>

                      <div className="form-preview-wrapper">
                        {personalizedBuildElements.length > 0 ? (
                          personalizedBuildElements.map((element, index) =>
                            renderFormElement(element, index)
                          )
                        ) : (
                          <div className="text-center py-5 text-muted">
                            <i className="fas fa-puzzle-piece fa-3x mb-3"></i>
                            <p>
                              Start building your form by adding elements from
                              the left panel.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Loader />
      )}

      {/* Edit Modal for Legacy Elements */}
      <Modal show={editingIndex !== null} onHide={() => setEditingIndex(null)}>
        <Modal.Header data-bs-theme="dark" closeButton>
          <Modal.Title>Property Editor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editOptions.length === 0 ? (
            <input
              type="text"
              value={editLabel}
              onChange={(e) => setEditLabel(e.target.value)}
            />
          ) : (
            <div>
              <input
                type="text"
                value={editLabel}
                onChange={(e) => setEditLabel(e.target.value)}
              />
              {editOptions.map((option, index) => (
                <div key={index}>
                  <input
                    type="text"
                    value={option}
                    onChange={(e) => {
                      const newOptions = [...editOptions];
                      newOptions[index] = e.target.value;
                      setEditOptions(newOptions);
                    }}
                  />
                </div>
              ))}
              <button onClick={() => setEditOptions([...editOptions, ""])}>
                Add Option
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setEditingIndex(null)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={saveEdit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default FormBuilder;
